{{each props.datalist dl index}}
  <div class="{{styles.oy_search_input_datalist_title}}">{{dl.title}}</div>
  {{each dl.options option oindex}}
    {{set value = $imports.encode(option.name)}}
    {{if oindex < props.maxDataListLength}}
      <div class="{{styles.oy_search_input_datalist_option}}" data-index="{{oindex}}">
        {{if option.type === 1}}
          <i class="iconfont icon-dianpu1 {{styles.dropDownIcon}}"></i>
        {{else if option.logo}}
          <image src="{{option.logo}}" class="{{styles.dropDownLogo}}"/>
        {{/if}}
        <span class="{{styles.dropDownText}}">{{option.name}}</span>
        <span class="{{styles.dropDownType}}">{{option.typeName}}</span>
        <i data-index="{{oindex}}" data-parent-index="{{index}}" class="{{styles.datalistOptionIcon}} iconfont icon-chacha"></i>
      </div>
    {{/if}}
  {{/each}}
{{/each}}



// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYSearch/templates/datalist.art